'use strict';
import util from '../util';
import currentLayout from '../detect-layout';
import productTile from '../product-tile';
import addToCart from './product/addToCart';
import socialShareIcons from './product/socialShareIcons';
import blogPages from './blog-pages';

var currLayout = currentLayout.init();

function initializeEvents() {
	$(document)

		// mobile navigation
		.on('change', '.promotion-nav-select select', function (e) {
			var newUrl = $(this).find("option:selected").val();

			if (newUrl) {
				window.location.href = newUrl;
			}
		});

	// concierge form events
	var conciergeForm = $('form[id$="_beautyconsultant"]');
	if (conciergeForm.length > 0) {
		// secure concierge access
		/*if (location && location.protocol === 'http:') {
		    window.location.href = Urls.secureConciergeForm;
		}*/

		var successShown = false;
		conciergeForm.on('click', 'button#sendBtn', function (e) {
			e.preventDefault();

			$.ajax({
				url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
				data: conciergeForm.serialize(),
				method: 'POST'
			}).done(function (response) {
				var conciergeModal = $('#concierge-modal');
				if (response && response.success && conciergeModal.length > 0) {
					// show success modal
					successShown = true;
					var popup = new Foundation.Reveal(conciergeModal);
					//Window height minus 80px, which sets the modal to fit inside the device's screen
					var windowHeight = window.innerHeight - 130;

					popup.$element.children('.modal-body').css('max-height', windowHeight);
					popup.open();

					// trigger ga
					window.history.pushState("", "", Urls.conciergeForm);
					$(document).trigger("askanexpert");
				}
			});
		});

		$(document).on('click', '.reveal-overlay', function () {
			// trigger redirect when concierge overlay is closed
			if (successShown && $(this).css('display') == 'none') {
				successShown = false;
				window.location.href = Urls.secureConciergeForm;
			}
		});
	}

	$('.article-navigation .icon-downCarrot').on('click', function () {
		$(this).parents('.article-navigation').toggleClass('article-open');
	})

	if (currLayout == 'desktop') {
		if ($('.pt_content.pt_article').length && $('.product-content .product-tile').length) {
			$('.product-content .product-tile').height($('.article-content.bottom').innerHeight())
		}
	}

	//Article content featured carousel
	if ($('.article-carousel-slick').length > 0) {
		$('.article-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}

	if ($('.pt_article [data-attr="slide"]') && $('.pt_article [data-attr="slide"]').length > 1) {
		$(window).on('load resize orientationchange', function () {
			var $carousel = $('.article-hero-component .slick-slider');

			if (!$carousel.hasClass('slick-initialized')) {
				$('.pt_article [data-attr="slide"]').each(function () {
					$carousel.append($(this).html());
				});
				$carousel.slick({
					easing: 'ease',
					arrows: false,
					slidesToShow: 1.14,
					centerMode: true,
					centerPadding: '1px',
					infinite: false
				});
			}
		});
	}
	$(document).on('click', '.articles-view-more', function (e) {
		e.preventDefault();
		$('.ajax-loader').show();
		var gridUrl = $(this).attr('data-grid-url');
		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: gridUrl,
			success: function (response) {
				$('.ajax-loader').hide();
				var delimiter = $('.article-bottom').offset().top;
				$('.article-bottom').replaceWith(response);
				$('html, body').animate({
					scrollTop: delimiter
				}, 500, 'linear');
			}
		});
	});
	productTile.init();

	addToCart();

	socialShareIcons();
	blogPages.init();
}

export default {
	init : function () {
	initializeEvents();
}
};